import { useMutation } from '@tanstack/react-query';
import { updateTagsOrder } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useUpdateTagsOrderMutation = () =>
  useMutation({
    mutationFn: async (newOrder: ID[]) => updateTagsOrder(newOrder),
  });
